import { gql } from "@apollo/client";

export const getOfferComments = gql`
  query GetOfferComments($offerId: ID!) {
    getOfferComments(offer_id: $offerId) {
      document_message
      offersoffer_id
      employeesemployee_id
      created_at
      employee {
        emp_abbrv
        employee_first_name
        employee_last_name
      }
    }
  }
`;

export const getKEKPayments = gql`
  query GetKEKOfferPayments($args: OfferPaymentInput) {
    getOfferPayments(args: $args) {
      offer_payment_id
      payment_amount
      offer_payment_comment
      payment_details
      created_at
      updated_at
      offer {
        offer_id
        rate
        commission
        commission_amount
        brokerage
        facultative_offer
        sum_insured
        fac_sum_insured
        premium
        fac_premium
        offer_status
        payment_status
        claim_status
        created_at
        updated_at
      }
      distribute_payment
      date_of_receipt
      date_cheque_cleared
      cheque_clearance_status
    }
  }
`;

export const publishComment = gql`
  mutation PublishCommentOnDocument($offerId: ID, $documentMessage: [String]) {
    publishCommentOnDocument(
      offer_id: $offerId
      document_message: $documentMessage
    )
  }
`;

export const getKEKOffers = gql`
  query KEKOffers($args: OfferFilters) {
    count: getOffersCount(args: $args)
    rows: getOffers(args: $args) {
      approval_status
      offer_id
      rate
      commission
      commission_amount
      brokerage
      facultative_offer
      expiry_status
      business_state
      co_insurance_share
      delete_status
      payment_type
      distribute_status
      sum_insured
      fac_sum_insured
      offer_from
      premium
      fac_premium
      offer_status
      offer_published {
        published_status
      }
      payment_status
      claim_status
      offer_detail {
        offer_detail_id
        offersoffer_id
        policy_number
        insured_by
        period_of_insurance_to
        period_of_insurance_from
        currency
        offer_comment
        offer_details
        payment_type
      }
      offer_endorsements {
        offer_endorsement_id
        fac_premium
        commission_amount
      }
      offer_payment {
        offer_payment_id
        payment_details
        payment_amount
      }
      offer_claims {
        offer_claim_id
        claim_amount
        claim_comment
        claim_date
        created_at
        offer_claim_participants {
          offer_claimsoffer_claim_id
          offer_claim_participant_id
          reinsurer_id
          offer_participantsoffer_participant_id
          offer_participant_percentage
          re_company_name
          claim_share
          created_at
        }
      }
      offer_retrocedent {
        created_at
      }
      offer_participant {
        offer_participant_id
        offer_participant_percentage
        offer_amount
        participant_fac_premium
        participant_fac_sum_insured
        offer_extra_charges {
          nic_levy
          agreed_brokerage_percentage
          withholding_tax
          agreed_commission
          agreed_commission_amount
          brokerage_amount
          nic_levy_amount
          withholding_tax_amount
        }
        offer_deduction_charge {
          nic_levy_paid
          withholding_tax_paid
          brokerage_amount_paid
          commission_taken
        }
        reinsurer {
          reinsurer_id
          re_company_name
          re_company_email
          reinsurer_address {
            country
          }
        }
      }
      insurer {
        insurer_id
        insurer_company_name
        insurer_company_email
        insurer_company_website
        insurer_address {
          suburb
          region
          country
        }
      }
      classofbusiness {
        class_of_business_id
        business_name
        business_details
        created_at
      }
      created_at
      employee {
        employee_id
        employee_first_name
        employee_last_name
        employee_phonenumber
        employee_email
        emp_abbrv
      }
      place_it_id
      thread_notification {
        id
        status
      }
    }
  }
`;

export const getReinsurersAvailableToParticipateOnOffer = gql`
  query GetReinsurersAvailableToParticipateOnOffer($offerId: ID) {
    getReinsurersAvailableToParticipateOnOffer(offerId: $offerId) {
      reinsurer_representative_id
      reinsurersreinsurer_id
      rep_first_name
      rep_last_name
      rep_primary_phonenumber
      rep_secondary_phonenumber
      rep_email
      position
      reinsurer {
        re_abbrv
        re_company_email
        re_company_name
      }
    }
  }
`;

export const getOfferSet = gql`
  query GetOfferSet($offerIds: [ID]) {
    count: getOfferSetCount(offer_ids: $offerIds)
    rows: getOfferSet(offer_ids: $offerIds) {
      offer_id
      rate
      commission
      commission_amount
      brokerage
      facultative_offer
      sum_insured
      fac_sum_insured
      premium
      fac_premium
      payment_status
      expiry_status
      renewal_status
      business_state
      delete_status
      approval_status
      created_at
      updated_at
      offer_from
      place_it_id
      distribute_status
      from
      to
      classofbusiness {
        class_of_business_id
        business_name
        business_details
        business_category
        single_total_overview
        single_total_offers
        created_at
      }
      offer_detail {
        insured_by
        policy_number
        offer_details
        currency
      }
      insurer {
        insurer_company_website
        insurer_company_name
        insurer_company_email
        insurer_abbrv
      }
      employee {
        employee_first_name
        employee_last_name
      }
      offer_status
    }
  }
`;

export const getKEKReinsurerOffers = gql`
  query GetKEKReinsurerOffers($args: OfferFiltersReinsurer, $reinsurer_id: ID) {
    getReinsurerOffersCount(reinsurer_id: $reinsurer_id)
    getReinsurerOffers(args: $args) {
      offersoffer_id
      offer_participant_id
      offer_detail {
        currency
        policy_number
      }
      offer_participant_percentage
      participant_fac_premium
      offer_extra_charges {
        offer_extra_charge_id
        withholding_tax
        agreed_commission
        nic_levy
        agreed_brokerage_percentage
      }
      offer_participant_payment {
        offer_participant_payment_id
        offer_payment_amount
        paid_details
        offer_participant_payment_comment
        payment_status
        created_at
        updated_at
        offer_deduction_charge {
          offer_deduction_payment_id
          nic_levy_paid
          withholding_tax_paid
          brokerage_amount_paid
          commission_taken
        }
      }
      reinsurer_offers_only {
        offer_id
        rate
        premium
        brokerage
        fac_premium
        facultative_offer
        commission
        fac_sum_insured
        sum_insured
        created_at
        offer_status
        payment_status
        classofbusiness {
          business_name
          class_of_business_id
          business_details
        }
        insurer {
          insurer_company_name
        }
        offer_detail {
          insured_by
          currency
          policy_number
          period_of_insurance_from
          period_of_insurance_to
          offer_comment
          offer_details
        }
      }
    }
  }
`;

export const getKEKOffer = gql`
  query KEKOffer($offer_id: ID!) {
    findSingleOffer(offer_id: $offer_id) {
      offer_id
      place_it_id
      offer_from
      rate
      commission
      approval_status
      commission_amount
      brokerage
      facultative_offer
      sum_insured
      fac_sum_insured
      premium
      fac_premium
      offer_status
      payment_status
      claim_status
      offer_published {
        published_status
      }
      offer_detail {
        offer_detail_id
        offersoffer_id
        policy_number
        insured_by
        period_of_insurance_to
        period_of_insurance_from
        currency
        offer_comment
        offer_details
        payment_type
        information_comment
      }
      offer_participant {
        offer_participant_id
        offer_participant_percentage
        offer_amount
        reinsurer {
          reinsurer_id
          re_company_name
          re_company_email
          re_abbrv
        }
        thread_notification {
          id
          status
        }
        offer_published_participant {
          offer_published_participant_id
        }
      }

      classofbusiness {
        class_of_business_id
        business_name
        business_details
        created_at
      }

      insurer {
        insurer_company_name
        insurer_company_email
        insurer_company_website
        insurer_id
      }

      offer_associates {
        offer_to_associate_id
        sent_status
        reinsurer_representative {
          rep_email
          rep_first_name
          rep_last_name
          rep_primary_phonenumber
          rep_secondary_phonenumber
          reinsurer {
            re_company_name
            re_company_email
          }
        }
      }
      offer_claims {
        claim_amount
        claim_comment
        claim_date
        created_at
        offer_claim_id
        offer_claim_participants {
          claim_share
          created_at
          offer_claim_participant_id
          offer_claimsoffer_claim_id
          offer_participant_percentage
          offer_participantsoffer_participant_id
          re_company_name
          reinsurer_id
        }
      }
      reinsurer_offer_extra_charge {
        offer_extra_charge_id
        nic_levy
        nic_levy_amount
        withholding_tax
        withholding_tax_amount
        agreed_brokerage_percentage
        brokerage_amount
        agreed_commission
        agreed_commission_amount
        created_at
      }
      offer_endorsements {
        offer_endorsement_id
        rate
        commission
        commission_amount
        brokerage
        facultative_offer
        co_insurance_share
        sum_insured
        fac_sum_insured
        premium
        fac_premium
        endorsement_status
        approval_status
        created_at
        updated_at
      }
      distribute_status
      expiry_status
      placed_offer
      offer_retrocedent {
        created_at
        updated_at
        reinsurer {
          re_company_name
          re_company_email
          re_abbrv
          reinsurer_id
        }
      }
      co_insurance_share
      business_state
      exchange_rate {
        exchange_rate_id
        offersoffer_id
        ex_currency
        ex_rate
      }
      renewal_status
    }
  }
`;

export const getKEKOfferClaimShares = gql`
  query GetKEKClaimShares($offerClaimId: ID) {
    getClaimShares(offer_claim_id: $offerClaimId) {
      offer_claim_participant_id
      claim_share
      created_at
      offer_claimsoffer_claim_id
      reinsurer_id
      re_company_name
      offer_participantsoffer_participant_id
      offer_participant_percentage
      offer_claim {
        offer_claim_id
        claim_amount
        claim_date
        created_at
        claim_comment
      }
      offer_participant {
        offersoffer_id
        offer_participant_id
        offer_participant_percentage
        offer_amount
        participant_fac_premium
        participant_fac_sum_insured
        created_at
        reinsurer {
          re_company_name
          reinsurer_id
        }
        offer_detail {
          currency
        }
      }
    }
  }
`;

export const getKEKOfferClaimShare = gql`
  query GetKEKClaimShare($offerClaimParticipantId: ID!) {
    getClaimShare(offer_claim_participant_id: $offerClaimParticipantId) {
      offer_claim_participant_id
      claim_share
      created_at
      offer_claimsoffer_claim_id
      reinsurer_id
      re_company_name
      offer_participantsoffer_participant_id
      offer_participant_percentage
    }
  }
`;

export const getKEKOfferParticipant = gql`
  query GetKEKOfferParticipant($participantId: ID) {
    getOfferParticipant(participant_id: $participantId) {
      offersoffer_id
      offer_participant_id
      offer_participant_percentage
      offer_amount
      participant_fac_premium
      participant_fac_sum_insured
      created_at
      reinsurer {
        reinsurer_id
        re_abbrv
        re_company_email
        re_company_name
        reinsurer_address {
          country
        }
      }
    }
  }
`;

export const getKEKTreaties = gql`
  query GetKEKTreaties($args: TreatyFilters) {
    rows: getTreaties(args: $args) {
      treaty_id
      treaty_reference
      kek_reference
      treaty_details
      currency
      order_hereon
      treaty_payment_status
      layer_limit
      insurer {
        insurer_id
        insurer_company_name
        insurer_company_email
        insurer_company_website
        insurer_abbrv
      }
      treaty_program {
        treaty_name
        treaty_type
      }
      treaty_deduction {
        treaty_period_from
        treaty_period_to
      }
      employee {
        employee_first_name
        employee_last_name
      }
    }
    count: getTreatiesCount(args: $args)
  }
`;

export const getReinstateOffers = gql`
  query Reinstate_offers($filter: OfferFilters) {
    count: reinstate_offersCount
    data: reinstate_offers(filter: $filter) {
      total
      expired
      active
      offers {
        offer_id
        rate
        commission
        commission_amount
        brokerage
        facultative_offer
        sum_insured
        fac_sum_insured
        premium
        fac_premium
        offer_status
        payment_status
        claim_status
        expiry_status
        created_at
        updated_at
        distribute_status
        offer_from
        place_it_id
        placed_offer
        employee {
          employee_last_name
          employee_first_name
        }
        classofbusiness {
          business_name
        }
        approval_status
        offer_detail {
          currency
          policy_number
          offer_details
          insured_by
        }
        insurer {
          insurer_company_name
          insurer_company_email
        }
        offer_detail_reinstate {
          currency
          policy_number
          offer_details
          insured_by
        }
      }
    }
  }
`;

export const getBankingTray = gql`
  query BankingTray($filter: OfferTabsFilter, $pagination: Pagination) {
    count: offersAllTabsCount(filter: $filter)
    rows: offersAllTabs(filter: $filter, pagination: $pagination) {
      cheque_number
      date_of_receipt
      date_cheque_cleared
      amount
      offers
      reinsured
    }
  }
`;

export const getKEKEndorsement = gql`
  query GetKEKEndorsement($offerEndorsementId: ID) {
    singleEndorsement(offer_endorsement_id: $offerEndorsementId) {
      rate
      commission
      commission_amount
      brokerage
      facultative_offer
      sum_insured
      fac_sum_insured
      premium
      fac_premium
      offer {
        business_state
        co_insurance_share
        offer_id
        rate
        commission
        commission_amount
        brokerage
        facultative_offer
        sum_insured
        fac_sum_insured
        premium
        fac_premium
        offer_status
        payment_status
        claim_status
        offer_retrocedent {
          reinsurer {
            reinsurer_id
          }
        }
        exchange_rate {
          ex_currency
          ex_rate
        }
        offer_detail {
          offer_detail_id
          offersoffer_id
          policy_number
          insured_by
          period_of_insurance_to
          period_of_insurance_from
          currency
          offer_comment
          offer_details
          payment_type
        }
        insurer {
          insurer_id
          insurer_company_name
          insurer_company_email
          insurer_company_website
          insurer_address {
            suburb
            region
            country
          }
        }
        classofbusiness {
          class_of_business_id
          business_name
          business_details
          created_at
        }
        created_at
      }
      insurer {
        insurer_id
        insurer_company_name
        insurer_company_email
        insurer_company_website
        insurer_address {
          suburb
          region
          country
        }
      }
      classofbusiness {
        class_of_business_id
        business_name
        business_details
        created_at
      }
      created_at
      offer_endorsement_detail {
        offer_endorsement_detail_id
        policy_number
        insured_by
        period_of_insurance_to
        period_of_insurance_from
        currency
        offer_comment
        information_comment
        offer_detail
      }
      offer_endorsement_participants {
        offer_end_participant_id
        offer_end_participant_percentage
        offer_end_amount
        offer_end_participant_fac_premium
        offer_end_participant_fac_sum_insured
        offer_endorsement_extra_charges {
          end_nic_levy
          end_nic_levy_amount
          end_withholding_tax
          end_agreed_brokerage_percentage
          end_brokerage_amount
          end_withholding_tax_amount
          end_agreed_commission
          end_agreed_commission_amount
        }
        reinsurer {
          reinsurer_id
          re_company_name
          re_company_email
          re_company_website
          re_abbrv
        }
      }
      approval_status
      endorsement_status
      updated_at
      offer_endorsement_id
    }
  }
`;

export const getKEKEndorsements = gql`
  query GetKEKEndorsements($args: EndorsementFilters) {
    count: getEndorsementsCount(args: $args)
    rows: getEndorsements(args: $args) {
      offer_endorsement_id
      rate
      commission
      commission_amount
      brokerage
      facultative_offer
      sum_insured
      fac_sum_insured
      premium
      fac_premium
      offer_endorsement_detail {
        offer_endorsement_detail_id
        policy_number
        insured_by
        period_of_insurance_to
        period_of_insurance_from
        currency
        offer_comment
        offer_detail
      }
      offer_endorsement_participants {
        reinsurer {
          reinsurer_id
          re_company_name
          re_company_email
          re_abbrv
        }
        offer_end_amount
        offer_end_participant_fac_premium
        offer_end_participant_fac_sum_insured
        offer_end_participant_id
        offer_end_participant_percentage
      }
      classofbusiness {
        class_of_business_id
        business_name
        business_details
        business_category
        created_at
      }
      insurer {
        insurer_company_name
        insurer_company_email
        insurer_company_website
        insurer_id
      }
      approval_status
      co_insurance_share
      endorsement_status
      created_at
      employee {
        employee_email
        employee_first_name
        employee_last_name
      }
    }
  }
`;
